export function getSortValueFromRow(row, key, sortKeyToCellMap, opts) {
    const o = opts || {};
    if (key === 'status' && typeof o.getStatusFromRow === 'function') return String(o.getStatusFromRow(row));
    if (key === 'type' && typeof o.getTypeFromRow === 'function') return String(o.getTypeFromRow(row));
    const prefix = o.rowDataAttrPrefix;
    if (prefix) {
        const fromRow = row.getAttribute(prefix + key.replace(/_/g, '-'));
        if (fromRow !== null && fromRow !== '') return fromRow;
    }
    const cellClass = sortKeyToCellMap[key] || key;
    const cell = row.querySelector('.data-grid-cell-' + cellClass);
    if (cell && cell.dataset.sortValue !== undefined) return String(cell.dataset.sortValue);
    const attr = 'data-' + key.replace(/_/g, '-');
    const attrVal = row.getAttribute(attr);
    return (attrVal !== null && attrVal !== undefined ? attrVal : (cell && cell.textContent ? cell.textContent.trim() : '')).toString();
}
